module.exports = __webpack_public_path__ + "static/media/alevapen.0f2f2f07.png";